import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuctionDataService } from '@/services/auction-house/data.service';
import { ThemeService } from '@/services/theme.service';

import { BidComponent } from '@/components/auction-house/bid/bid.component';
import { PunkInfoComponent } from '@/components/auction-house/punk-info/punk-info.component';

import { PunkImageDirective } from '@/directives/auction-house/punk-image.directive';

import { environment } from '@/../environments/environment';

import { Store } from '@ngrx/store';
import { GlobalState } from '@/models/auction-house/state';

import * as dataStateSelectors from '@/store/auction-house/data.selectors';
import { Web3Service } from '@/services/web3.service';
import { setCurrentBlock } from '@/store/auction-house/data.actions';

import { watchBlockNumber } from '@wagmi/core';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    BidComponent,
    PunkInfoComponent,

    PunkImageDirective
  ],
  selector: 'app-auction',
  templateUrl: './auction.component.html',
  styleUrls: ['./auction.component.scss']
})
export class AuctionComponent {

  env = environment;

  auctionData$ = this.store.select(dataStateSelectors.selectActiveAuction);

  constructor(
    private store: Store<GlobalState>,
    public dataSvc: AuctionDataService,
    public themeSvc: ThemeService,
    public web3Svc: Web3Service
  ) {
    watchBlockNumber(this.web3Svc.config, {
      emitOnBegin: true,
      poll: true,
      onBlockNumber: (blockNumber) => {
        this.store.dispatch(setCurrentBlock({ currentBlock: Number(blockNumber) }));
      }
    });
  }
}
